import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { VulnerabilitiesAppDataProviderFactory } from '../factory/VulnerabilitiesAppDataProviderFactory';
import { VulnerabilitiesAppBaseDataProvider } from '../dataProvider/VulnerabilitiesAppBaseDataProvider';
import { VulnerabilitiesAppWebComponentSchema } from '../types';

export class VulnerabilitiesAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: VulnerabilitiesAppDataProviderFactory;
  public dataProvider: VulnerabilitiesAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new VulnerabilitiesAppDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<VulnerabilitiesAppWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
